/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { FilterCollation, SortDirection } from '../enums';
import { combineFilters } from './combineFilters';

import type { TransformRequestParamsOptions, RequestParams, RestParams } from '../interfaces';

export function transformRequestParams(
    { start, limit, sort, filter, ...rest }: RequestParams<unknown>,
    options?: TransformRequestParamsOptions
) {
    const params: RestParams = {};

    if (start !== undefined) {
        params.offset = start;
    }

    if (limit !== undefined) {
        params.limit = limit;
    }

    if (sort !== undefined && sort.length) {
        params.sort = sort.map(({ property, direction }) => ({
            property: property,
            direction: direction === 'ASC' ? SortDirection.Asc : SortDirection.Desc,
            collation: options?.sort?.collation ?? FilterCollation.Ignorecase,
        }));
    }

    if (filter !== undefined) {
        params.filter = combineFilters(filter as Record<string, (string|number)[]>);
    }

    return {
        ...params,
        ...(params.sort ? { sort: JSON.stringify(params.sort) } : {}),
        ...(params.filter ? { filter: JSON.stringify(params.filter) } : {}),
        ...rest,
    };
}
